import { CreateEventDto } from "../models/Event";
import { axiosInstance } from "./AxiosDefaults";

export const getAllEvents = (): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get("/events", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getAllEvent = (): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get("/events/all", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getAllEventsInactive = (): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get("/events/inactive", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getEvent = (id: string): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get(`${`/events`}/${id}`, {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getAccommodationInEvent = (
  id: string,
  accommodationId: string
): Promise<any> => {
  return axiosInstance.get(`${`/events`}/${id}/${accommodationId}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const archiveEvent = (id: string): Promise<any> => {
  return axiosInstance.put(`${`/events/archive`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllParticipantsEvent = (
  id: string,
  accommodationId: string
): Promise<any> => {
  return axiosInstance.get(
    `${`/events/participants`}/${id}/${accommodationId}`,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getAllParticipantsRegistrationStatus = (
  id: string,
  registrationStatus: string
): Promise<any> => {
  return axiosInstance.get(
    `${`/events/registrationStatus`}/${id}/${registrationStatus}`,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const filterEventStatistic = (
  id: string,
  queryParams: string
): Promise<any> => {
  return axiosInstance.get(`${`/events/filters-event-statistic`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
    params: { type: queryParams },
  });
};

export const getAllLecturersInEvent = (id: string): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get(`${`/events/lecturers`}/${id}`, {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const createEvent = (event: CreateEventDto): Promise<any> => {
  return axiosInstance.post("/events", event, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateEvent = async (
  id: string,
  event: CreateEventDto
): Promise<any> => {
  return axiosInstance.put(`${"/events"}/${id}`, event, {
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteEvent = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/events"}/${id}`);
};
